import React from "react";
import Logo from "../components/header/Logo";

const Error = () => {
  return (
    <div>
      <Logo />
      Page introuvable
    </div>
  );
};

export default Error;
